import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from "styled-components";
import { createStructuredSelector } from "reselect";
import * as LocalStoreService from "../../LocalStoreService";
import {
  IconEnFlag,
  IconFrCaFlag,
  Menu,
  MenuListItem,
  MenuSwitcherButton,
  MENU_PLACEMENT,
} from "cdk-radial";
import { changeLocale } from "../LanguageProvider/actions";
import { makeSelectLocale } from "../LanguageProvider/selectors";
import { useCookies } from "react-cookie";

const selectOptions = [
  {
    id: "en",
    label: "EN",
    value: "en",
    icon: <IconEnFlag />,
  },
  {
    id: "fr",
    label: "FR",
    value: "fr",
    icon: <IconFrCaFlag />,
  },
];

const LanguageSwitcherWrapper = styled.div`
  #language-menu-switcher-button {
    padding: 0px 4px 0px 8px;
    width: 82px;
    height: 36px;
    background-color: #000000;
    border-radius: 8px;
    margin: 8px 24px 0px 0px;
    :hover {
      background-color: #333333;
    }
    :focus {
      background-color: #333333;
      outline: 3px solid #CCCCCC;
    }
    span{
      color:#ffffff;
    };
    svg{
      fill:#ffffff;
    }
  }
`;

export const LocaleToggle = (props) => {
  const localeCookieDurationDays = 30;
  const [cookie, setCookie] = useCookies(['locale']);
  const currentLocale = cookie.locale ? cookie.locale : "en";
  const currentLocaleOption = selectOptions.find(
    (v) => currentLocale == v.value
  );
  const [isOpen, setIsOpen] = useState(false);
  const [selectedView, setSelectedView] = useState(currentLocaleOption);
  const targetRef = useRef();


  const setLocaleCookie = (val) => {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + localeCookieDurationDays);
    setCookie('locale', val, {path:'/', expires: expirationDate, domain:'.connectcdk.com'});
  }

  const handleClose = () => {
    setIsOpen(false);
    targetRef.current.focus();
  };
  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleSelect = (option) => {
    setSelectedView(option);
    setIsOpen(false);
    targetRef.current.focus();
    LocalStoreService.set("locale", option.value);
    setLocaleCookie(option.value);
    props.onLocaleToggle(option.value);
  };

  
  useEffect(() => {
    if(!cookie.locale){
      setLocaleCookie(currentLocale);
    }
    props.onLocaleToggle(currentLocale);
  }, [cookie.locale, currentLocale]);

  return (
    <LanguageSwitcherWrapper>
      <MenuSwitcherButton
        dataTestId="menu-switcher-button"
        id="language-menu-switcher-button"
        icon={selectedView.icon}
        isOpen={isOpen}
        label={selectedView.label}
        ref={targetRef}
      />
      <Menu
        aria-label="Select a language"
        dataTestId="language-select-menu-switcher"
        placement={MENU_PLACEMENT.RIGHT_START}
        labelRef={targetRef}
        onClose={handleClose}
        onOpen={handleOpen}
        isOpen={isOpen}
      >
        {selectOptions.map((option, ind) => (
          <MenuListItem
            dataTestId={`menu-item-${ind}`}
            isSelected={selectedView.value === option.value}
            key={ind}
            onClick={() => handleSelect(option)}
            graphicContent={option.icon}
            isOpen={isOpen}
            hideSelectedItemCheckmark={false}
          >
            {option.label}
          </MenuListItem>
        ))}
      </Menu>
    </LanguageSwitcherWrapper>
  );
};

LocaleToggle.propTypes = {
  onLocaleToggle: PropTypes.func,
  locale: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  locale: makeSelectLocale(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onLocaleToggle: (evt) => dispatch(changeLocale(evt)),
    dispatch,
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  LocaleToggle
);
